export default __webpack_public_path__ + "static/media/danskeheadlinebold-webfont.c878e87b.ttf";